import React from 'react';

const ProductDetailPage = () => {
  return (
    <div className="public-website">
      <div className="container">
        <h1>Product Detail Page</h1>
        <p>Product details page coming soon...</p>
      </div>
    </div>
  );
};

export default ProductDetailPage; 